/**
 * Parses a value to a Date object or returns a fallback date if conversion fails.
 *
 * @param {Date|string|null|undefined} value - The value to parse as a Date.
 * @param {Date} fallback - The fallback date to use if conversion fails.
 * @returns {Date} A valid Date object or the fallback date.
 */
const parseDateOrFallback = (value, fallback) => {
  try {
    if (value instanceof Date) {
      if (!Number.isNaN(value.getTime())) {
        return value;
      }
      return fallback;
    }

    if (value) {
      const parsedDate = new Date(value);
      if (!Number.isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
      return fallback;
    }

    return fallback;
  } catch {
    return fallback;
  }
};

export default parseDateOrFallback;
